// @core/stores/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { authStore } from './auth';
import { i18nStore } from './i18n';
import { themeStore } from './theme';
import { activityStore } from './activity';
import { activityActivityMappingStore } from './activity';
import { activityActivitySettingStore } from './activity';
import { activityDecisionStore } from './activity';
import { activityInboxStore } from './activity';
import { adminStore } from './admin';
import { affiliateStore } from './affiliate';
import { affiliateCampaignStore } from './affiliate';
import { affiliateCommissionTierStore } from './affiliate';
import { affiliateConversionStore } from './affiliate';
import { affiliateOfferStore } from './affiliate';
import { affiliatePayoutStore } from './affiliate';
import { affiliatePostbackStore } from './affiliate';
import { affiliateReferralLinkStore } from './affiliate';
import { affiliateTrackingStore } from './affiliate';
import { analyticsStore } from './analytics';
import { apikeyStore } from './apikey';
import { apikeyApiKeyPolicyStore } from './apikey';
import { apikeyApikeyStore } from './apikey';
import { attachmentStore } from './attachment';
import { audittrailStore } from './audittrail';
import { authnStore } from './authn';
import { authn2FAStore } from './authn';
import { authnAuthStore } from './authn';
import { authnOidcStore } from './authn';
import { authzStore } from './authz';
import { billingStore } from './billing';
import { billingBalanceStore } from './billing';
import { billingBillingAccountStore } from './billing';
import { billingBillingPolicyStore } from './billing';
import { billingCreditStore } from './billing';
import { billingInvoiceNumberingStore } from './billing';
import { billingInvoiceStore } from './billing';
import { billingPriceStore } from './billing';
import { billingProductStore } from './billing';
import { billingReportStore } from './billing';
import { billingTransactionStore } from './billing';
import { billingUsageStore } from './billing';
import { bookingStore } from './booking';
import { bookingAvailabilityStore } from './booking';
import { bookingBookingNumberingStore } from './booking';
import { bookingBookingStore } from './booking';
import { bookingBookingTypeStore } from './booking';
import { bookingPolicyStore } from './booking';
import { bookingResourceStore } from './booking';
import { bookingReviewStore } from './booking';
import { bookingStatStore } from './booking';
import { bookingWaitlistStore } from './booking';
import { bootstrapStore } from './bootstrap';
import { calendarStore } from './calendar';
import { calendarAvailabilityStore } from './calendar';
import { calendarBookingStore } from './calendar';
import { calendarCalendarEventTypeStore } from './calendar';
import { calendarCalendarPolicyStore } from './calendar';
import { calendarCalendarStore } from './calendar';
import { calendarEventStore } from './calendar';
import { calendarTemplateStore } from './calendar';
import { chatStore } from './chat';
import { chatChatPolicyStore } from './chat';
import { chatMessageStore } from './chat';
import { chatPresenceStore } from './chat';
import { contextStore } from './context';
import { documentStore } from './document';
import { documentDocumentTypeStore } from './document';
import { fiscalizationStore } from './fiscalization';
import { fiscalizationFiscalPointStore } from './fiscalization';
import { fiscalizationFiscalProviderStore } from './fiscalization';
import { fiscalizationFiscalReceiptStore } from './fiscalization';
import { fiscalizationReportStore } from './fiscalization';
import { fiscalizationShiftStore } from './fiscalization';
import { formStore } from './form';
import { formFormPolicyStore } from './form';
import { formFormStore } from './form';
import { formFormTypeStore } from './form';
import { knowledgeStore } from './knowledge';
import { landingStore } from './landing';
import { legalentityStore } from './legalentity';
import { licenseStore } from './license';
import { licenseLicenseStore } from './license';
import { localizationStore } from './localization';
import { notificationsStore } from './notifications';
import { notificationsAnalyticStore } from './notifications';
import { notificationsChannelStore } from './notifications';
import { notificationsContactStore } from './notifications';
import { notificationsSettingStore } from './notifications';
import { notificationsTemplateStore } from './notifications';
import { paymentStore } from './payment';
import { paymentPaymentMethodStore } from './payment';
import { paymentPaymentPolicyStore } from './payment';
import { paymentPaymentProviderStore } from './payment';
import { paymentPaymentRouteStore } from './payment';
import { paymentPaymentStore } from './payment';
import { paymentPaymentTypeStore } from './payment';
import { paymentWebhookStore } from './payment';
import { platformStore } from './platform';
import { platformFederationStore } from './platform';
import { productStore } from './product';
import { projectStore } from './project';
import { projectAnalyticStore } from './project';
import { projectBoardStore } from './project';
import { projectComponentStore } from './project';
import { projectEpicStore } from './project';
import { projectItemStore } from './project';
import { projectLabelStore } from './project';
import { projectMilestoneStore } from './project';
import { projectSprintStore } from './project';
import { projectTimelineStore } from './project';
import { projectViewStore } from './project';
import { resourceStore } from './resource';
import { searchStore } from './search';
import { secretStore } from './secret';
import { secretAuditStore } from './secret';
import { secretCertificateStore } from './secret';
import { secretDatabaseSecretStore } from './secret';
import { secretKvStore } from './secret';
import { secretLeaseStore } from './secret';
import { secretPkiStore } from './secret';
import { secretSealStore } from './secret';
import { secretSecretEngineStore } from './secret';
import { secretSecretPolicyStore } from './secret';
import { signatureStore } from './signature';
import { subscriptionStore } from './subscription';
import { subscriptionAddonStore } from './subscription';
import { subscriptionAnalyticStore } from './subscription';
import { subscriptionBundleStore } from './subscription';
import { subscriptionDiscountStore } from './subscription';
import { subscriptionEntitlementStore } from './subscription';
import { subscriptionPlanStore } from './subscription';
import { tagStore } from './tag';
import { taskStore } from './task';
import { taskAnalyticStore } from './task';
import { taskContainerConfigStore } from './task';
import { taskCustomFieldStore } from './task';
import { taskStatusDefinitionStore } from './task';
import { taskTaskCategoryStore } from './task';
import { taskTaskNumberingStore } from './task';
import { taskTaskPolicyStore } from './task';
import { taskTaskTypeStore } from './task';
import { taskTemplateStore } from './task';
import { taskViewStore } from './task';
import { teamStore } from './team';
import { tenantStore } from './tenant';
import { tenantTenantStore } from './tenant';
import { userStore } from './user';
import { userInternalStore } from './user';
import { userReferralStore } from './user';
import { userprofileStore } from './userprofile';
import { userprofileAvatarStore } from './userprofile';
import { userprofileBannerStore } from './userprofile';
import { userprofileSettingStore } from './userprofile';
import { webhookStore } from './webhook';
import { webhookWebhookPolicyStore } from './webhook';
import { webhookWebhookStore } from './webhook';
import { workflowStore } from './workflow';
import { workflowPipelinePolicyStore } from './workflow';

// Re-export individual stores
export { authStore } from './auth';
export type { SignInRequest } from '../types/authn/SignInRequest';
export type { SignInResponse } from '../types/authn/SignInResponse';
export type { SignUpRequest } from '../types/authn/SignUpRequest';
export type { SignUpResponse } from '../types/authn/SignUpResponse';
export type { User } from '../types/authn/User';
export { i18nStore, t } from './i18n';
export type { Locale, Translations, TranslationKey, TranslationParams } from './i18n';
export { themeStore } from './theme';
export type { ThemeMode, ResolvedTheme, ThemeColors, ThemeConfig } from './theme';
export { activityStore } from './activity';
export { activityActivityMappingStore } from './activity';
export { activityActivitySettingStore } from './activity';
export { activityDecisionStore } from './activity';
export { activityInboxStore } from './activity';
export { adminStore } from './admin';
export { affiliateStore } from './affiliate';
export { affiliateCampaignStore } from './affiliate';
export { affiliateCommissionTierStore } from './affiliate';
export { affiliateConversionStore } from './affiliate';
export { affiliateOfferStore } from './affiliate';
export { affiliatePayoutStore } from './affiliate';
export { affiliatePostbackStore } from './affiliate';
export { affiliateReferralLinkStore } from './affiliate';
export { affiliateTrackingStore } from './affiliate';
export { analyticsStore } from './analytics';
export { apikeyStore } from './apikey';
export { apikeyApiKeyPolicyStore } from './apikey';
export { apikeyApikeyStore } from './apikey';
export { attachmentStore } from './attachment';
export { audittrailStore } from './audittrail';
export { authnStore } from './authn';
export { authn2FAStore } from './authn';
export { authnAuthStore } from './authn';
export { authnOidcStore } from './authn';
export { authzStore } from './authz';
export { billingStore } from './billing';
export { billingBalanceStore } from './billing';
export { billingBillingAccountStore } from './billing';
export { billingBillingPolicyStore } from './billing';
export { billingCreditStore } from './billing';
export { billingInvoiceNumberingStore } from './billing';
export { billingInvoiceStore } from './billing';
export { billingPriceStore } from './billing';
export { billingProductStore } from './billing';
export { billingReportStore } from './billing';
export { billingTransactionStore } from './billing';
export { billingUsageStore } from './billing';
export { bookingStore } from './booking';
export { bookingAvailabilityStore } from './booking';
export { bookingBookingNumberingStore } from './booking';
export { bookingBookingStore } from './booking';
export { bookingBookingTypeStore } from './booking';
export { bookingPolicyStore } from './booking';
export { bookingResourceStore } from './booking';
export { bookingReviewStore } from './booking';
export { bookingStatStore } from './booking';
export { bookingWaitlistStore } from './booking';
export { bootstrapStore } from './bootstrap';
export { calendarStore } from './calendar';
export { calendarAvailabilityStore } from './calendar';
export { calendarBookingStore } from './calendar';
export { calendarCalendarEventTypeStore } from './calendar';
export { calendarCalendarPolicyStore } from './calendar';
export { calendarCalendarStore } from './calendar';
export { calendarEventStore } from './calendar';
export { calendarTemplateStore } from './calendar';
export { chatStore } from './chat';
export { chatChatPolicyStore } from './chat';
export { chatMessageStore } from './chat';
export { chatPresenceStore } from './chat';
export { contextStore } from './context';
export { documentStore } from './document';
export { documentDocumentTypeStore } from './document';
export { fiscalizationStore } from './fiscalization';
export { fiscalizationFiscalPointStore } from './fiscalization';
export { fiscalizationFiscalProviderStore } from './fiscalization';
export { fiscalizationFiscalReceiptStore } from './fiscalization';
export { fiscalizationReportStore } from './fiscalization';
export { fiscalizationShiftStore } from './fiscalization';
export { formStore } from './form';
export { formFormPolicyStore } from './form';
export { formFormStore } from './form';
export { formFormTypeStore } from './form';
export { knowledgeStore } from './knowledge';
export { landingStore } from './landing';
export { legalentityStore } from './legalentity';
export { licenseStore } from './license';
export { licenseLicenseStore } from './license';
export { localizationStore } from './localization';
export { notificationsStore } from './notifications';
export { notificationsAnalyticStore } from './notifications';
export { notificationsChannelStore } from './notifications';
export { notificationsContactStore } from './notifications';
export { notificationsSettingStore } from './notifications';
export { notificationsTemplateStore } from './notifications';
export { paymentStore } from './payment';
export { paymentPaymentMethodStore } from './payment';
export { paymentPaymentPolicyStore } from './payment';
export { paymentPaymentProviderStore } from './payment';
export { paymentPaymentRouteStore } from './payment';
export { paymentPaymentStore } from './payment';
export { paymentPaymentTypeStore } from './payment';
export { paymentWebhookStore } from './payment';
export { platformStore } from './platform';
export { platformFederationStore } from './platform';
export { productStore } from './product';
export { projectStore } from './project';
export { projectAnalyticStore } from './project';
export { projectBoardStore } from './project';
export { projectComponentStore } from './project';
export { projectEpicStore } from './project';
export { projectItemStore } from './project';
export { projectLabelStore } from './project';
export { projectMilestoneStore } from './project';
export { projectSprintStore } from './project';
export { projectTimelineStore } from './project';
export { projectViewStore } from './project';
export { resourceStore } from './resource';
export { searchStore } from './search';
export { secretStore } from './secret';
export { secretAuditStore } from './secret';
export { secretCertificateStore } from './secret';
export { secretDatabaseSecretStore } from './secret';
export { secretKvStore } from './secret';
export { secretLeaseStore } from './secret';
export { secretPkiStore } from './secret';
export { secretSealStore } from './secret';
export { secretSecretEngineStore } from './secret';
export { secretSecretPolicyStore } from './secret';
export { signatureStore } from './signature';
export { subscriptionStore } from './subscription';
export { subscriptionAddonStore } from './subscription';
export { subscriptionAnalyticStore } from './subscription';
export { subscriptionBundleStore } from './subscription';
export { subscriptionDiscountStore } from './subscription';
export { subscriptionEntitlementStore } from './subscription';
export { subscriptionPlanStore } from './subscription';
export { tagStore } from './tag';
export { taskStore } from './task';
export { taskAnalyticStore } from './task';
export { taskContainerConfigStore } from './task';
export { taskCustomFieldStore } from './task';
export { taskStatusDefinitionStore } from './task';
export { taskTaskCategoryStore } from './task';
export { taskTaskNumberingStore } from './task';
export { taskTaskPolicyStore } from './task';
export { taskTaskTypeStore } from './task';
export { taskTemplateStore } from './task';
export { taskViewStore } from './task';
export { teamStore } from './team';
export { tenantStore } from './tenant';
export { tenantTenantStore } from './tenant';
export { userStore } from './user';
export { userInternalStore } from './user';
export { userReferralStore } from './user';
export { userprofileStore } from './userprofile';
export { userprofileAvatarStore } from './userprofile';
export { userprofileBannerStore } from './userprofile';
export { userprofileSettingStore } from './userprofile';
export { webhookStore } from './webhook';
export { webhookWebhookPolicyStore } from './webhook';
export { webhookWebhookStore } from './webhook';
export { workflowStore } from './workflow';
export { workflowPipelinePolicyStore } from './workflow';

// Root store combining all stores
export class RootStore {
  auth = authStore;
  i18n = i18nStore;
  theme = themeStore;
  activityStore = activityStore;
  activityActivityMappingStore = activityActivityMappingStore;
  activityActivitySettingStore = activityActivitySettingStore;
  activityDecisionStore = activityDecisionStore;
  activityInboxStore = activityInboxStore;
  adminStore = adminStore;
  affiliateStore = affiliateStore;
  affiliateCampaignStore = affiliateCampaignStore;
  affiliateCommissionTierStore = affiliateCommissionTierStore;
  affiliateConversionStore = affiliateConversionStore;
  affiliateOfferStore = affiliateOfferStore;
  affiliatePayoutStore = affiliatePayoutStore;
  affiliatePostbackStore = affiliatePostbackStore;
  affiliateReferralLinkStore = affiliateReferralLinkStore;
  affiliateTrackingStore = affiliateTrackingStore;
  analyticsStore = analyticsStore;
  apikeyStore = apikeyStore;
  apikeyApiKeyPolicyStore = apikeyApiKeyPolicyStore;
  apikeyApikeyStore = apikeyApikeyStore;
  attachmentStore = attachmentStore;
  audittrailStore = audittrailStore;
  authnStore = authnStore;
  authn2FAStore = authn2FAStore;
  authnAuthStore = authnAuthStore;
  authnOidcStore = authnOidcStore;
  authzStore = authzStore;
  billingStore = billingStore;
  billingBalanceStore = billingBalanceStore;
  billingBillingAccountStore = billingBillingAccountStore;
  billingBillingPolicyStore = billingBillingPolicyStore;
  billingCreditStore = billingCreditStore;
  billingInvoiceNumberingStore = billingInvoiceNumberingStore;
  billingInvoiceStore = billingInvoiceStore;
  billingPriceStore = billingPriceStore;
  billingProductStore = billingProductStore;
  billingReportStore = billingReportStore;
  billingTransactionStore = billingTransactionStore;
  billingUsageStore = billingUsageStore;
  bookingStore = bookingStore;
  bookingAvailabilityStore = bookingAvailabilityStore;
  bookingBookingNumberingStore = bookingBookingNumberingStore;
  bookingBookingStore = bookingBookingStore;
  bookingBookingTypeStore = bookingBookingTypeStore;
  bookingPolicyStore = bookingPolicyStore;
  bookingResourceStore = bookingResourceStore;
  bookingReviewStore = bookingReviewStore;
  bookingStatStore = bookingStatStore;
  bookingWaitlistStore = bookingWaitlistStore;
  bootstrapStore = bootstrapStore;
  calendarStore = calendarStore;
  calendarAvailabilityStore = calendarAvailabilityStore;
  calendarBookingStore = calendarBookingStore;
  calendarCalendarEventTypeStore = calendarCalendarEventTypeStore;
  calendarCalendarPolicyStore = calendarCalendarPolicyStore;
  calendarCalendarStore = calendarCalendarStore;
  calendarEventStore = calendarEventStore;
  calendarTemplateStore = calendarTemplateStore;
  chatStore = chatStore;
  chatChatPolicyStore = chatChatPolicyStore;
  chatMessageStore = chatMessageStore;
  chatPresenceStore = chatPresenceStore;
  contextStore = contextStore;
  documentStore = documentStore;
  documentDocumentTypeStore = documentDocumentTypeStore;
  fiscalizationStore = fiscalizationStore;
  fiscalizationFiscalPointStore = fiscalizationFiscalPointStore;
  fiscalizationFiscalProviderStore = fiscalizationFiscalProviderStore;
  fiscalizationFiscalReceiptStore = fiscalizationFiscalReceiptStore;
  fiscalizationReportStore = fiscalizationReportStore;
  fiscalizationShiftStore = fiscalizationShiftStore;
  formStore = formStore;
  formFormPolicyStore = formFormPolicyStore;
  formFormStore = formFormStore;
  formFormTypeStore = formFormTypeStore;
  knowledgeStore = knowledgeStore;
  landingStore = landingStore;
  legalentityStore = legalentityStore;
  licenseStore = licenseStore;
  licenseLicenseStore = licenseLicenseStore;
  localizationStore = localizationStore;
  notificationsStore = notificationsStore;
  notificationsAnalyticStore = notificationsAnalyticStore;
  notificationsChannelStore = notificationsChannelStore;
  notificationsContactStore = notificationsContactStore;
  notificationsSettingStore = notificationsSettingStore;
  notificationsTemplateStore = notificationsTemplateStore;
  paymentStore = paymentStore;
  paymentPaymentMethodStore = paymentPaymentMethodStore;
  paymentPaymentPolicyStore = paymentPaymentPolicyStore;
  paymentPaymentProviderStore = paymentPaymentProviderStore;
  paymentPaymentRouteStore = paymentPaymentRouteStore;
  paymentPaymentStore = paymentPaymentStore;
  paymentPaymentTypeStore = paymentPaymentTypeStore;
  paymentWebhookStore = paymentWebhookStore;
  platformStore = platformStore;
  platformFederationStore = platformFederationStore;
  productStore = productStore;
  projectStore = projectStore;
  projectAnalyticStore = projectAnalyticStore;
  projectBoardStore = projectBoardStore;
  projectComponentStore = projectComponentStore;
  projectEpicStore = projectEpicStore;
  projectItemStore = projectItemStore;
  projectLabelStore = projectLabelStore;
  projectMilestoneStore = projectMilestoneStore;
  projectSprintStore = projectSprintStore;
  projectTimelineStore = projectTimelineStore;
  projectViewStore = projectViewStore;
  resourceStore = resourceStore;
  searchStore = searchStore;
  secretStore = secretStore;
  secretAuditStore = secretAuditStore;
  secretCertificateStore = secretCertificateStore;
  secretDatabaseSecretStore = secretDatabaseSecretStore;
  secretKvStore = secretKvStore;
  secretLeaseStore = secretLeaseStore;
  secretPkiStore = secretPkiStore;
  secretSealStore = secretSealStore;
  secretSecretEngineStore = secretSecretEngineStore;
  secretSecretPolicyStore = secretSecretPolicyStore;
  signatureStore = signatureStore;
  subscriptionStore = subscriptionStore;
  subscriptionAddonStore = subscriptionAddonStore;
  subscriptionAnalyticStore = subscriptionAnalyticStore;
  subscriptionBundleStore = subscriptionBundleStore;
  subscriptionDiscountStore = subscriptionDiscountStore;
  subscriptionEntitlementStore = subscriptionEntitlementStore;
  subscriptionPlanStore = subscriptionPlanStore;
  tagStore = tagStore;
  taskStore = taskStore;
  taskAnalyticStore = taskAnalyticStore;
  taskContainerConfigStore = taskContainerConfigStore;
  taskCustomFieldStore = taskCustomFieldStore;
  taskStatusDefinitionStore = taskStatusDefinitionStore;
  taskTaskCategoryStore = taskTaskCategoryStore;
  taskTaskNumberingStore = taskTaskNumberingStore;
  taskTaskPolicyStore = taskTaskPolicyStore;
  taskTaskTypeStore = taskTaskTypeStore;
  taskTemplateStore = taskTemplateStore;
  taskViewStore = taskViewStore;
  teamStore = teamStore;
  tenantStore = tenantStore;
  tenantTenantStore = tenantTenantStore;
  userStore = userStore;
  userInternalStore = userInternalStore;
  userReferralStore = userReferralStore;
  userprofileStore = userprofileStore;
  userprofileAvatarStore = userprofileAvatarStore;
  userprofileBannerStore = userprofileBannerStore;
  userprofileSettingStore = userprofileSettingStore;
  webhookStore = webhookStore;
  webhookWebhookPolicyStore = webhookWebhookPolicyStore;
  webhookWebhookStore = webhookWebhookStore;
  workflowStore = workflowStore;
  workflowPipelinePolicyStore = workflowPipelinePolicyStore;

  /**
   * Initialize all stores
   * Call this once at app startup
   */
  async initialize(config: {
    apiBaseUrl: string;
    defaultLocale?: string;
    themeColors?: import('./theme').ThemeConfig;
    scope?: { platformId?: string; productId?: string; tenantId?: string };
  }): Promise<void> {
    // Initialize auth (also initializes API client)
    this.auth.initialize({
      apiBaseUrl: config.apiBaseUrl,
      scope: config.scope,
    });
    // Initialize theme
    this.theme.initialize(config.themeColors);
    // Initialize i18n
    await this.i18n.initialize({
      defaultLocale: config.defaultLocale as import('./i18n').Locale,
    });
  }

  /**
   * Cleanup stores
   */
  dispose(): void {
    this.theme.dispose();
  }
}

// Singleton instance
export const rootStore = new RootStore();

// Type alias for use in React context
export type RootStoreType = InstanceType<typeof RootStore>;
